import clsx from 'clsx'
import React, { ReactNode } from 'react'

import { useThemeClass } from '../Theme'
import { TextProps } from '../Typography'
import { TIMELINE_ITEM_DISPLAY_NAME } from './constants'
import styles from './style.module.scss'
import { useTimelineContext } from './TimelineContext'
import { TimelineDesign } from './TimelineDesign'
import { TimelineText } from './TimelineText'
import { NodeKind } from './types'

export type ItemAlign = 'Left' | 'Right' | ''

export interface BodyText {
  /**
   * Note: text is rendered inside a `p` tag, so only use elements that can be children of `p`'s
   */
  text: ReactNode
  styling?: TextProps
}

export interface TimelineItemProps {
  align?: ItemAlign
  hideLine?: boolean
  /**
   * Note: text is rendered inside a `p` tag, so only use elements that can be children of `p`'s
   */
  titleText: ReactNode
  bodyText: BodyText
  testNameSpace?: string
  highlight?: boolean
  nodeKind?: NodeKind
}

export const TimelineItem = React.forwardRef<HTMLDivElement, TimelineItemProps>(
  ({ align = '', titleText, bodyText, hideLine = false, testNameSpace = 'timeline-item', highlight = false, nodeKind }, ref): JSX.Element => {
    const themeClass = useThemeClass()
    const { kind } = useTimelineContext()
    const { text: textBody, styling } = bodyText
    const isVertical = kind === 'Vertical'
    const cls = clsx(styles.timelineItem, isVertical && styles.timelineItemV, styles[`timelineItem${align}`], styles[themeClass])
    return (
      <li className={cls} data-testid={testNameSpace}>
        <TimelineText {...styling} isVertical={isVertical} testNameSpace='timeline-title-text'>
          {titleText}
        </TimelineText>
        <TimelineDesign isVertical={isVertical} align={align} hideLine={hideLine} highlight={highlight} nodeKind={nodeKind} />
        <TimelineText {...styling} testNameSpace='timeline-body-text'>
          {textBody}
        </TimelineText>
      </li>
    )
  }
)

TimelineItem.displayName = TIMELINE_ITEM_DISPLAY_NAME
